import { Typography, Stack } from '@mui/material';
import {
  Provider,
  type BackupJob,
  type InventoryResource,
  type ResourceType,
  type RestoreJob,
} from '@repo/api-gw-sdk';
import type { ReactNode } from 'react';

import { CloudProviders } from '@/data/inventory/data';
import { ResourceTypes } from '@/data/inventory/resourceTypes';

import { isJob } from './queryBuilder/properties';
import { CircleImage } from './shared/circleImage';

export const CloudProviderIndicator = ({
  cloudProvider,
  text,
}: {
  cloudProvider: Provider;
  text?: ReactNode;
}) => {
  return (
    <Stack direction='row' alignItems='center' gap='12px'>
      <CloudProviderCircle cloudProvider={cloudProvider} />
      {!text || typeof text === 'string' ? (
        <Typography className='font-normal'>
          {text || CloudProviders[cloudProvider]?.displayName}
        </Typography>
      ) : (
        text
      )}
    </Stack>
  );
};

export const CloudProviderCircle = ({
  cloudProvider,
}: {
  cloudProvider: Provider;
}) => {
  return (
    CloudProviders[cloudProvider] && (
      <CircleImage
        alt={CloudProviders[cloudProvider]?.displayName}
        src={CloudProviders[cloudProvider]?.logo}
      />
    )
  );
};

export const ResourceTypeIndicator = ({
  resourceType,
}: {
  resourceType: ResourceType;
}) => {
  const cloudProvider = ResourceTypes[resourceType]?.provider;

  return (
    <CloudProviderIndicator
      cloudProvider={cloudProvider}
      text={ResourceTypes[resourceType]?.displayName}
    />
  );
};

export const getCloudProvider = (
  entity: InventoryResource | RestoreJob | BackupJob
): Provider => {
  return isJob(entity)
    ? entity.resourceDetails?.cloudProvider || Provider.ProviderUnspecified
    : entity.cloudProvider;
};
